var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156.133 156.133",
    style: {
      enableBackground: "new 0 0 156.133 156.133"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.073,
    y: 30.296,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F59DCC"
    },
    width: 121.987,
    height: 103.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.073,
    y: 96.925,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DB86B3"
    },
    width: 121.987,
    height: 36.495
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#47C796"
    },
    points: "0.001,51.767 156.133,51.768 139.061,22.712  17.073,22.712  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDC256"
    },
    d: "M14.194,51.768c0,4.027,3.177,7.293,7.097,7.293 s7.097-3.266,7.097-7.293H14.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDC256"
    },
    d: "M42.582,51.768c0,4.027,3.177,7.293,7.097,7.293 s7.097-3.266,7.097-7.293H42.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDC256"
    },
    d: "M70.97,51.768c0,4.027,3.177,7.293,7.097,7.293 s7.097-3.266,7.097-7.293H70.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDC256"
    },
    d: "M99.357,51.768c0,4.027,3.177,7.293,7.097,7.293 c3.92,0,7.098-3.266,7.098-7.293H99.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDC256"
    },
    d: "M127.745,51.768c0,4.027,3.177,7.293,7.097,7.293 c3.92,0,7.097-3.266,7.097-7.293H127.745z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#19A871"
    },
    d: "M14.194,51.768c0,4.027-3.178,7.293-7.097,7.293 C3.178,59.061,0,55.795,0,51.768H14.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#19A871"
    },
    d: "M42.582,51.768c0,4.027-3.178,7.293-7.097,7.293 c-3.92,0-7.098-3.266-7.098-7.293H42.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#19A871"
    },
    d: "M70.97,51.768c0,4.027-3.178,7.293-7.097,7.293 c-3.92,0-7.098-3.266-7.098-7.293H70.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#19A871"
    },
    d: "M99.357,51.768c0,4.027-3.178,7.293-7.097,7.293 c-3.92,0-7.098-3.266-7.098-7.293H99.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#19A871"
    },
    d: "M127.745,51.768c0,4.027-3.178,7.293-7.097,7.293 c-3.92,0-7.097-3.266-7.097-7.293H127.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#19A871"
    },
    d: "M156.133,51.768c0,4.027-3.178,7.293-7.097,7.293 c-3.92,0-7.098-3.266-7.098-7.293H156.133z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFD873"
    },
    points: "14.194,51.767 141.938,51.768 127.971,22.712  28.163,22.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#47C796"
    },
    points: "28.389,51.767 127.745,51.768 116.881,22.712  39.253,22.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFD873"
    },
    points: "42.582,51.767 113.552,51.768 105.791,22.712  50.342,22.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#47C796"
    },
    points: "56.776,51.767 99.357,51.768 94.701,22.712  61.433,22.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFD873"
    },
    points: "70.97,51.767 85.163,51.768 83.611,22.712  72.521,22.712  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76.172,
    y: 60.431,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DB86B3"
    },
    width: 43.884,
    height: 72.989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.961,
    y: 63.689,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FECFF"
    },
    width: 36.307,
    height: 69.731
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.077,
    y: 60.431,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DB86B3"
    },
    width: 43.884,
    height: 72.989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.866,
    y: 63.689,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9FECFF"
    },
    width: 36.306,
    height: 69.731
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEF8FF"
    },
    points: "39.866,109.216 76.172,72.911 76.172,69.166  39.866,105.471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEF8FF"
    },
    points: "39.866,120.454 76.172,84.147 76.172,76.656  39.866,112.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEF8FF"
    },
    points: "39.866,127.944 76.172,91.638 76.172,87.893  39.866,124.199  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEF8FF"
    },
    points: "79.961,109.216 116.268,72.911 116.268,69.166  79.961,105.471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEF8FF"
    },
    points: "79.961,120.454 116.268,84.147 116.268,76.656  79.961,112.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEF8FF"
    },
    points: "79.961,127.944 116.268,91.638 116.268,87.893  79.961,124.199  "
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopSvg);
export default __webpack_public_path__ + "static/media/ShopSVG.24509f7e33818c04887b2f65e3fd07a5.svg";
export { ForwardRef as ReactComponent };